module.exports = __webpack_public_path__ + "img/ic_yingyezhizhao.85df44c0.svg";